import { Link } from "react-router-dom";
import KoFi from "./KoFi";

function Navbar(props) {
  return (
    <div className="bg-indigo-500 flex justify-start px-4 py-2">
      <Link to="/" className="mr-4">
        <span
          style={{ fontFamily: "'Poppins', sans-serif" }}
          className="text-white font-bold"
        >
          thread2blog
        </span>
      </Link>

      <KoFi color="#f7cf19" id="U7U24UJCY" label="Buy us a coffee!" />
    </div>
  );
}

export default Navbar;
